
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCalendarGoogle as ObiCalendarGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-calendar-google.js';
 
 
 

 
 export const ObiCalendarGoogle = createComponent({
   react: React,
   tagName: 'obi-calendar-google',
   elementClass: ObiCalendarGoogleElement,
   events: {
     
   }
  });
 
 